





































































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { Busy } from '@/components/Busy.ts';

import { leagueModuleName } from '@/modules/league/store/index';
import { Getters as LeagueGetters } from '@/modules/league/store/getters';
import { Actions as LeagueActions } from '@/modules/league/store/actions';
import { Settings, LeagueTableState } from '../store/models';
const leagueModule = namespace(leagueModuleName);

import { teamsModuleName } from '@/modules/teams/store/index';
import { Actions as TeamsActions } from '@/modules/teams/store/actions';
import { Getters as TeamsGetters } from '@/modules/teams/store/getters';
import { Team } from '@/modules/teams/store/models';
const teamsModule = namespace(teamsModuleName);

@Component({
  components: {
  },
})
export default class LeagueTable extends Vue {

  private busy: Busy = new Busy();

  @leagueModule.Action(LeagueActions.FETCH_LEAGUE_SETTINGS) private fetchLeagueSettings!: () => void;
  @leagueModule.Action(LeagueActions.FETCH_LEAGUE_TABLE) private fetchLeagueTable!: (seasonId?: number) => void;
  @leagueModule.Getter(LeagueGetters.LOADED) private settingsLoaded!: number;
  @leagueModule.Getter(LeagueGetters.SETTINGS) private leagueSettings!: Settings;
  @leagueModule.Getter(LeagueGetters.SEASON_FULL_NAME) private seasonFullName!: string;
  @leagueModule.Getter(LeagueGetters.ACTIVE_SEASON_ID) private activeSeasonId!: number;
  @leagueModule.Getter(LeagueGetters.LEAGUE_TABLE_STATE) private leagueTableSate!: LeagueTableState;

  @teamsModule.Getter(TeamsGetters.TEAMS) private teams!: Team[];
  @teamsModule.Getter(TeamsGetters.LOADED) private teamsLoaded!: boolean;
  @teamsModule.Action(TeamsActions.FETCH_TEAMS) private fetchTeams!: (seasonId: number) => void;


  public async mounted() {
    this.ensureLeagueSettingsIsLoaded().then(() => {
      this.ensureTeamsIsLoaded();
      this.ensureLeagueTableIsLoaded();
    });
  }

  private async ensureLeagueSettingsIsLoaded() {
    if (!this.settingsLoaded) {
        this.busy.SetBusy();
        await this.fetchLeagueSettings();
        this.busy.SetFree();
      }
  }

  private async ensureTeamsIsLoaded() {
    if (!this.teamsLoaded) {
      this.busy.SetBusy();
      await this.fetchTeams(this.activeSeasonId);
      this.busy.SetFree();
    }
  }

  private async ensureLeagueTableIsLoaded() {
    if (!this.leagueTableSate.isLoaded) {
      this.busy.SetBusy();
      await this.fetchLeagueTable(this.activeSeasonId);
      this.busy.SetFree();
    }
  }


}
